/* eslint-disable no-restricted-imports */

import React from 'react';

import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Typography,
} from '@material-ui/core';
import {
  Cancel as CancelIcon,
  Delete as DeleteIcon,
  Warning as WarningIcon,
} from '@material-ui/icons';

import { xpcellService } from 'services';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export function DeleteConfirmationDialog({
  isOpen,
  handleClose,
  templateToDelete,
  setSnackbar,
  refetchMessages,
}) {
  const handleDelete = async () => {
    try {
      await xpcellService.disableSettingsMessage(templateToDelete);
      refetchMessages();
      setSnackbar({
        open: true,
        message: '🗑️ Template excluído com sucesso!',
        severity: 'success',
      });
      handleClose();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err?.response?.data?.message || '❌ Erro ao excluir o template',
        severity: 'error',
      });
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      TransitionComponent={Transition}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16,
          padding: 8,
        },
      }}
    >
      <DialogTitle style={{ textAlign: 'center', paddingBottom: 8 }}>
        <Avatar
          style={{
            backgroundColor: '#f44336',
            width: 64,
            height: 64,
            margin: '0 auto 16px',
          }}
        >
          <WarningIcon fontSize='large' />
        </Avatar>
        <Typography variant='h5' style={{ fontWeight: 'bold', color: '#333' }}>
          Confirmar Exclusão
        </Typography>
      </DialogTitle>

      <DialogContent style={{ textAlign: 'center', paddingTop: 0 }}>
        <Typography variant='body1' style={{ marginBottom: 16, fontSize: 16 }}>
          Tem certeza que deseja excluir este template?
        </Typography>
        <Typography variant='body2' color='textSecondary'>
          ⚠️ Esta ação não pode ser desfeita e o template será removido permanentemente.
        </Typography>
      </DialogContent>

      <DialogActions style={{ padding: '16px 24px', justifyContent: 'center', gap: 12 }}>
        <Button
          onClick={handleClose}
          variant='outlined'
          color='primary'
          size='large'
          startIcon={<CancelIcon />}
          style={{ borderRadius: 25, minWidth: 120 }}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleDelete}
          variant='contained'
          color='secondary'
          size='large'
          startIcon={<DeleteIcon />}
          style={{ borderRadius: 25, minWidth: 120 }}
        >
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
}
